import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { Image, List } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { SelectionBoxRadio } from '@grandvisionhq/fun-products';
import { SelectionBoxTag } from '../SelectionBoxTag/SelectionBoxTag.js';
import PriceTagOrIncluded from '../PriceTagOrIncluded/PriceTagOrIncluded.js';

const ConfiguratorRadioTile = ({ className , value , title , description , image , headerRowImage , price , discountText , isSelected , uspList , tag , onChange ,  })=>/*#__PURE__*/ React__default.createElement("div", {
        className: classnames('configurator-radio-tile', className, {
            'configurator-radio-tile__with-tag': !!tag
        })
    }, tag ? /*#__PURE__*/ React__default.createElement(SelectionBoxTag, {
        id: `tag-${value}`,
        className: "configurator-radio-tile__tag",
        title: tag
    }) : null, /*#__PURE__*/ React__default.createElement(SelectionBoxRadio, {
        className: 'configurator-radio-tile__radio',
        name: "configurator-radio-tile",
        value: value,
        checked: isSelected,
        onChange: ()=>onChange(value)
        ,
        "aria-describedby": tag ? `tag-${value}` : undefined
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "configurator-radio-tile__wrapper"
    }, image && /*#__PURE__*/ React__default.createElement(Image, {
        className: "configurator-radio-tile__image",
        cover: true,
        alt: "",
        url: image
    }), /*#__PURE__*/ React__default.createElement("div", {
        className: "configurator-radio-tile__body"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "configurator-radio-tile__heading"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "configurator-radio-tile__heading-wrapper"
    }, headerRowImage && /*#__PURE__*/ React__default.createElement(Image, {
        className: "configurator-radio-tile__row-image",
        cover: false,
        url: headerRowImage,
        alt: ""
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        className: "configurator-radio-tile__subheading1",
        component: "div",
        variant: "subheading1",
        visualHeadingOnly: true
    }, title)), price && /*#__PURE__*/ React__default.createElement(PriceTagOrIncluded, swcHelpers.extends({}, price, {
        discountText: discountText
    }))), description && /*#__PURE__*/ React__default.createElement(Text, {
        className: "configurator-radio-tile__description"
    }, description), uspList && /*#__PURE__*/ React__default.createElement(List, {
        items: uspList,
        spacing: "compact",
        renderText: (item)=>/*#__PURE__*/ React__default.createElement(Text, {
                variant: "caption"
            }, item)
        ,
        className: "configurator-radio-tile__usp-list"
    })))))
;

export { ConfiguratorRadioTile };
//# sourceMappingURL=ConfiguratorRadioTile.js.map
